import { ApiService } from '../../services'
export const DataIntegrationModule = {
    namespaced: true,
    state: {
        db : [],
        fetchLoading : false
    },
    actions: {
        integrate(_, payload) {
            return new Promise((resolve, reject) => {
                ApiService.store(`data-integration/${payload.endpoint}`,payload).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },

        fetch(_, payload) {
            return new Promise((resolve, reject) => {
                ApiService.get(`item-master/${payload.endpoint}`,payload).then((response) => {
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        },

        async post(_, payload) {
            return await ApiService.store(`item-master/${payload.endpoint}`, payload.record)
        },

        async fetchDb({commit,state}, payload) {
            commit('setDb', [])
            const { fetchLoading } = state
            if(!fetchLoading){
                commit('setFetchLoadingTrue')
                await ApiService.get(`sap-db`,payload).then((response) => {
                    commit('setDb', response.data)
                    commit('setFetchLoadingFalse')
                }).catch(() => {
                    commit('setFetchLoadingFalse')
                })
            }
        },
      
    },

    mutations : {
        setDb : (state, payload) => state.db = payload,
        setFetchLoadingTrue : (state) => state.fetchLoading = true,
        setFetchLoadingFalse : (state) => state.fetchLoading = false
    },

    getters : {
        getDb : (state) => state.db,
        getFetchLoading : (state) => state.fetchLoading
    }

}


